const fetchTextToSpeech = async (
  text,
  route,
  userData,
  examGuid,
  ExamAttemptId,
  displayAuthenticationError
) => {
  return await fetch(`${route}/texttospeech.webapi`, {
    headers: {
      TOKEN: userData.Token,
      ExamGuid: examGuid,
      ExamAttemptId: ExamAttemptId,
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({
      text: text,
      voice: "af_heart",
      audio_format: "mp3",
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.blob();
      } else if (response.status === 401) {
        displayAuthenticationError();
        throw new Error("User is no longer authenticated");
      } else {
        throw new Error("Error fetching text-to-speech");
      }
    })
    .then((blob) => {
      return blob;
    });
};

export default fetchTextToSpeech;
